import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { TaskActionHandler } from '../contracts/task-action.contract';
import { Task, TaskType } from '../models/task.interface';
import * as TaskActions from '../store/task.actions';

@Injectable()
export class ProcessGuaranteeApplicationActionHandler implements TaskActionHandler<TaskType.ProcessGuaranteeApplication> {
  private readonly router = inject(Router);
  private readonly store = inject(Store);

  readonly type = TaskType.ProcessGuaranteeApplication;

  execute(task: Task<TaskType.ProcessGuaranteeApplication>): void {
    this.store.dispatch(TaskActions.startTask({ task }));
    this.router.navigate(['/members', task.data.memberId, 'guarantees'], { queryParams: { guarantee: task.data.guaranteeId } });
  }
}
